import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const assistantChatUnshareMutationAtom = createMutationAtomFactory(
  'assistant.chatUnshare',
  (params: { chatId: string }) => ({
    assistantUnshareChat: {
      __args: {
        chatId: params.chatId,
      },
      id: true,
      isShared: true,
    },
  }),
);
